<!-- =========================================================================================
    File Name: Program.vue
    Description: Партнерские программы
========================================================================================== -->


<template>
    <div id="partner-program" class="border border-solid d-theme-border-grey-light rounded relative overflow-hidden">
      

      <vs-sidebar class="items-no-padding" parent="#partner-program" :click-not-close="clickNotClose" :hidden-background="clickNotClose" v-model="isSidebarActive">

          <program-create />

          <VuePerfectScrollbar class="program-scroll-area" :settings="settings" :key="$vs.rtl">

          <program-filters @closeSidebar="toggleProgramSidebar"></program-filters>

          </VuePerfectScrollbar>
      </vs-sidebar>

      <div :class="{'sidebar-spacer': clickNotClose}" class="no-scroll-content border border-r-0 border-b-0 border-t-0 border-solid d-theme-border-grey-light no-scroll-content">
          <div class="flex d-theme-dark-bg items-center border border-l-0 border-r-0 border-t-0 border-solid d-theme-border-grey-light">

      
              <!-- TOGGLE SIDEBAR BUTTON -->
              <feather-icon class="md:inline-flex lg:hidden ml-4 mr-4 cursor-pointer" icon="MenuIcon" @click.stop="toggleProgramSidebar(true)" />

              <!-- SEARCH BAR -->
              <vs-input icon-no-border size="large" icon-pack="feather" icon="icon-search" placeholder="Поиск..." v-model="searchQuery" class="vs-input-no-border vs-input-no-shdow-focus w-full" />
          </div>

          <!-- PROGRAM LIST -->
          <VuePerfectScrollbar class="program-content-scroll-area" :settings="settings" ref="programListPS" :key="$vs.rtl">
              <transition-group class="program-list" name="list-enter-up" tag="ul" appear>
                <li class="cursor-pointer program_program-item" v-for="(program, index) in programList" :key="String(currFilter) + String(program.ppid)" :style="[{transitionDelay: (index * 0.1) + 's'}]">


                  <program-item :programId="program.ppid" @showDisplayPrompt="showDisplayPrompt($event)" :key="String(program.name) + String(program.descr)" />

                </li>
              </transition-group>
          </VuePerfectScrollbar>
          <!-- /PROGRAM LIST -->
      </div>

      <!-- EDIT PROGRAM DIALOG -->
      <program-edit :displayPrompt="displayPrompt" :programId="programIdToEdit" @hideDisplayPrompt="hidePrompt" v-if="displayPrompt"></program-edit>
    </div>
</template>

<script>
import modulePartner          from '@/store/partner/modulePartner.js'
import ProgramCreate          from "./ProgramCreate.vue"
import ProgramItem            from "./ProgramItem.vue"
import ProgramFilters         from "./ProgramFilters.vue"
import ProgramEdit            from "./ProgramEdit.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  data() {
    return {
      currFilter           : "",
      clickNotClose        : true,
      displayPrompt        : false,
      programIdToEdit         : 0,
      isSidebarActive      : true,
      settings : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30,
      },
    }
  },
  watch: {
    programFilter() {
      this.$refs.programListPS.$el.scrollTop = 0
      this.toggleProgramSidebar()

      // Fetch Programs
      let filter = this.$route.params.filter
      this.$store.dispatch("partner/fetchPrograms", { filter: filter })
      this.$store.commit("partner/UPDATE_PROGRAM_FILTER", filter)
    },
    windowWidth() {
      this.setSidebarWidth()
    },
  },
  computed: {
    programFilter()  { return this.$route.params.filter                     },
    programList()    { return this.$store.getters["partner/queriedPrograms"]      },
    searchQuery:  {
      get()       { return this.$store.state.partner.programSearchQuery        },
      set(val)    { this.$store.dispatch('partner/setProgramSearchQuery', val) }
    },
    windowWidth() { return this.$store.state.windowWidth }
  },
  methods: {
    showDisplayPrompt(itemId) {
      this.programIdToEdit  = itemId
      this.displayPrompt = true
    },
    hidePrompt() {
      this.displayPrompt = false
    },
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.isSidebarActive = this.clickNotClose = false
      } else {
        this.isSidebarActive = this.clickNotClose = true
      }
    },
    toggleProgramSidebar(value = false) {
      if (!value && this.clickNotClose) return
      this.isSidebarActive = value
    },
  },
  components: {
    ProgramCreate,
    ProgramItem,
    ProgramFilters,
    ProgramEdit,
    VuePerfectScrollbar
  },
  created() {
    if (!modulePartner.isRegistered) {
      this.$store.registerModule('partner', modulePartner)
      modulePartner.isRegistered = true
    }
    this.setSidebarWidth()

    let filter = this.$route.params.filter

    // Fetch Tasks
    this.$store.dispatch("partner/fetchPrograms", { filter: filter })
    this.$store.commit("partner/UPDATE_PROGRAM_FILTER", filter)
  },
  beforeUpdate() {
    this.currFilter = this.$route.params.filter
  },
  // beforeDestroy: function() {
  //   this.$store.unregisterModule('partner')
  //   modulePartner.isRegistered = false
  // },
  mounted() {
    this.$store.dispatch("partner/setProgramSearchQuery", "")
  }
}

</script>


<style lang="scss">

#partner-program {
    .vs-sidebar--background{
        position: absolute;
    }
    .program-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 70px);
    }
    .program-content-scroll-area {
        position: relative;
        margin: auto;
        width: 100%;
        height: calc(100% - 50px);
    }

    // TRANSITION
    .program_program-item {
        transition: all .35s;
    }

    .list-item-component {
        transition: background-color .2s, transform .2s;
        border-top: 1px solid #dae1e7;
        &:hover {
            // background-color: #eee;
            transform: translateY(-4px);
			box-shadow: 0px 3px 10px 0px #ccc;
            transition: all 0.2s;
        }
    }

    .program-list {
      .program-tags {
        .con-vs-chip {
          margin-right: 2px !important;
        }
      }
    }
}

</style>
